
defsPackEditor.title.placeholder=Inserisci il titolo (tema o altro)
defsPackEditor.description.placeholder=Inserisci la descrizione
defsPackEditor.title.create=Crea nuove flashcard
defsPackEditor.title.save=Modifica le flashcard
defsPackEditor.addPackImage=Aggiungi immagine
visibility.label=Visibile a
visibility.0=Solo io
visibility.1=Tutti (dopo il controllo)
visibility.2=Verifica
visibilityBadge.0=Privato
visibilityBadge.1=Pubblico
visibilityBadge.2=Verifica
## не удаляйте этот блок, на него есть ссылки в {plurals}
pl.card.one=carta
pl.card.few=carte
pl.card.other=carte
pl.day.one=giorno
pl.day.few=giorni
pl.day.other=giorni
pl.passedReview.one=revisione superata
pl.passedReview.few=recensioni superate
pl.passedReview.other=recensioni superate
pl.failedReview.one=revisione fallita
pl.failedReview.few=recensioni fallite
pl.failedReview.other=recensioni fallite
pl.freshCard.one=carta fresca
pl.freshCard.few=nuove carte
pl.freshCard.other=nuove carte
pl.hours.one=ora
pl.hours.few=ore
pl.hours.other=ore
pl.hours={0} {0,plural,one{ora}few{ore}other{ore}}
pl.days.one=giorno
pl.days.few=giorni
pl.days.other=giorni
pl.days={0} {0,plural,one{giorno}few{giorni}other{giorni}}
pl.minutes.one=minuto
pl.minutes.few=minuti
pl.minutes.other=minuti
pl.minutes={0} {0,plural,one{minuto}few{minuti}other{minuti}}
## validation
rubd.flashcards.services.validation.SideTextWhenCardIsNotEmpty.message=La scheda non è vuota, hai bisogno di del testo per questo lato
##
button.save=Salva
button.saveContinue=Salva e continua
button.create=Creare
button.cancel=Cancellare
button.clone=Clone
button.print=Stampa
button.checkTest=Controlla i risultati
button.yes=SÌ
button.close=Vicino
button.ok=OK
button.help=Aiuto
##
title.label=Titolo
title.description=Descrizione
title.optional=(opzionale)
## duration messages
fl.agoString={0} fa
fl.agoRecently=Recentemente
fl.timeSpent={0} speso
fl.timeSpentLessThanMinute=Ho trascorso un po''
##
pack.cardCount={0} carte
pack.cardCount.one={0} carta
pack.cardCount.many={0} carte
pack.cardCount.few={0} carte
##
page.defaultTitle=Flashcard online
## user private dashboard
fl.mainDashboard.packAgo.title=Tempo trascorso dall''ultima visita
fl.mainDashboard.packSpent.title=Tempo dedicato all''apprendimento
fl.mainDashboard.hideMemoPack=Questo set verrà rimosso dalla Dashboard di Apprendimento a Lungo Termine. Per aggiungerlo nuovamente, dovrai cliccare su "Inizia ad apprendere" nella pagina del set.
##
packEditor.form.termLanguage=Linguaggio dei termini
packEditor.form.termLanguage.placeholder=Scegli la lingua
packEditor.form.definitionLanguage=Lingua di definizione
packEditor.form.definitionLanguage.placeholder=Scegli la lingua
packEditor.form.loading=Caricamento elenco carte...
packEditor.form.cardMinimum=Si prega di compilare almeno due schede
packEditor.importer.open=Importa da txt, Word, Excel, Google Docs, ecc.
packEditor.importer.close=Vicino
packEditor.importer.import=Importare
packEditor.importer.textLabel=Copia e incolla il testo qui (da Word, Excel, Google Docs, ecc.)
packEditor.importer.textPlaceholder=Parola 1    Definizione 1\nParola 2    Definizione 2\nParola 3    Definizione 3
packEditor.importer.result=Sono state importate {0} voci
packEditor.importer.preview.title=Anteprima delle carte
packEditor.importer.preview.empty=Nessuna scheda è stata riconosciuta. Controlla le impostazioni di importazione nel pannello di destra.
packEditor.anki.button=Importa Anki
packEditor.anki.dialog.message=Carica il tuo file .APKG per importare il tuo mazzo di flashcard ANKI.
packEditor.anki.dialog.notice1=Alcuni mazzi non possono essere importati o potrebbero presentare errori. Dipende dalla struttura del mazzo. Ci scusiamo per il problema.
packEditor.anki.dialog.notice2=Puoi importare i tuoi mazzi o mazzi che hai il diritto di copiare e modificare.
packEditor.anki.dialog.title=Importa le flashcard Anki
packEditor.anki.dialog.button=Sfoglia
packEditor.anki.progress.sending=Invio file in corso...
packEditor.anki.progress.parsing=Analisi del file in corso...
packEditor.anki.progress.forming=Inserimento del risultato nel modulo...
packEditor.anki.progress.error=Importazione fallita.
packEditor.anki.progress.success=Operazione completata. Nuove carte sono state aggiunte all''elenco sottostante.
packEditor.addRow=Aggiungi carta
packEditor.card.term.placeholder=Termine
packEditor.card.term.needText=Serve del testo qui
packEditor.card.def.placeholder=Definizione
packEditor.card.def.needText=Serve del testo qui
packEditor.importer.form.mode=Modalità di importazione
packEditor.importer.form.mode.everyLine=Il termine e la definizione sono in ogni riga, separati da un delimitatore
packEditor.importer.form.mode.lineByLine=Il termine e la definizione sono sequenziali, un elemento per riga
packEditor.importer.form.everyLine1=Delimitatore di voce (riga)
packEditor.importer.form.everyLine2=Delimitatore di termine/definizione
packEditor.importer.form.everyLine3=Opzioni aggiuntive
packEditor.importer.form.ldLine=Avvolgimento della linea
packEditor.importer.form.ldDoubleLine=Avvolgimento a doppia linea
packEditor.importer.form.ldCustom=Simbolo personalizzato
packEditor.importer.form.ldJoinLowercase=Unisci la riga che inizia con il simbolo minuscolo
packEditor.importer.form.tdDash=Trattino (-)
packEditor.importer.form.tdTab=Scheda
packEditor.importer.form.tdCustom=Simbolo personalizzato
packEditor.importer.form.lineByLine1=Opzioni aggiuntive
packEditor.importer.form.llDoubleLine=Doppia riga di avvolgimento tra ogni gruppo
packEditor.importer.form.llJoinLowercase=Unisci la riga che inizia con il simbolo minuscolo
packEditor.splitNewCards.notice=Sembra che tu abbia molte carte. Forse è ragionevole dividerle in più set.
packEditor.splitNewCards.checkbox.1=Sì, dividi le carte in
packEditor.splitNewCards.checkbox.2=pezzi in ogni set
packEditor.splitNewCards.shuffle=E mescola le carte prima di dividerle
packEditor.splitNewCards.suffix=Parte {0}.
packEditor.putToCollection=Aggiungi pacchetto a
packEditor.putToCollection.none=<nessuno>
packEditor.putToCollection.createNew=raccolta o {0}crearne una nuova{1}.
packEditor.images.search=Cerca immagini
packEditor.images.search.or=O
packEditor.images.upload=Caricamento
packEditor.images.remove=Rimuovi immagine
packEditor.images.emptySearch=Nessuna immagine trovata. Prova un''altra query.
packEditor.audio.record=Documentazione
packEditor.audio.remove=Rimuovere
packEditor.audio.upload=Caricamento
##
collectionForm.modal.title=Crea una nuova raccolta
collectionForm.name=Nome
collectionForm.name.placeholder=Nome della raccolta di tipi
collectionForm.description=Descrizione
collectionForm.description.placeholder=Descrizione della raccolta di tipi
##
myPage.title.author=I miei set
myPage.title.lastPacks=I miei ultimi set
myPage.title.favourite=I miei set preferiti
myPage.empty.last=Non hai visitato nessun set
myPage.empty.author=Non hai creato alcun set
myPage.empty.favourite=La tua lista dei preferiti è vuota
##
packPage.header.from=di
packPage.buttonGroup.play=Giocare
packPage.button.play=Anteprima
packPage.button.test=Test
packPage.button.learn=Imparare
packPage.button.write=Scrivere
packPage.button.spell=Sillabare
packPage.button.match=Incontro
packPage.button.live=Vivere
packPage.solw.short=Apprendimento veloce
packPage.solw.short.subtitle=Ripeti questa serie di flashcard
packPage.solw.short.new=Nuovo:
packPage.solw.short.familiar=Familiare:
packPage.solw.short.mastered=Padronanza:
packPage.solw.long=Apprendimento a lungo termine
packPage.solw.long.subtitle=Ripetizione distanziata
packPage.solw.long.today=Compito di oggi
packPage.solw.long.new=Nuovo:
packPage.solw.long.review=Per rivedere:
packPage.button.memo=Promemoria
ppp0.title=Vuoi imparare velocemente questo set?
packPage.dialogs.forbidden.alert=Disponibile solo per gli utenti autorizzati
packPage.dialogs.forbidden.addToCollection.text=Puoi aggiungere questo set a una delle tue collezioni
packPage.dialogs.forbidden.addToCollection.alert=Disponibile solo per gli utenti autorizzati
packPage.dialogs.forbidden.createNew.title=Benvenuto!
packPage.dialogs.forbidden.createNew.text=Solo gli utenti autorizzati possono creare nuove carte.
packPage.dialogs.forbidden.clone.text=Se utilizzi queste carte per studiare, ma vuoi integrarle, ti basta clonarle e creare il nuovo set di cui hai bisogno.
packPage.dialogs.forbidden.clone.alert=Disponibile solo per gli utenti autorizzati
packPage.dialogs.addToCollection.title=Aggiungi questo set alla collezione
packPage.dialogs.addToCollection.notice=Puoi aggiungere questo set di flashcard alle tue raccolte di studio
packPage.dialogs.addToCollection.createNew=+ Aggiungi nuova raccolta
packPage.dialogs.addToCollection.forbidden=Solo gli utenti autorizzati possono aggiungere carte ai propri corsi
packPage.dialogs.addToFavourites.title=Aggiungi questo set a quelli salvati
packPage.dialogs.addToFavourites.forbidden=Puoi aggiungere "Salva questo set" per tornarci più tardi
packPage.dialogs.login=Accedi / registrati
packPage.dialogs.share.title=Condividi questo set
packPage.dialogs.clone.title=Clona questo set
packPage.dialogs.clone.notice=Se utilizzi queste carte per studiare, ma vuoi integrarle, ti basta clonarle e creare il nuovo set di cui hai bisogno.
packPage.command.edit=Modificare
packPage.command.customize=Personalizza
packPage.command.addTo=Aggiungere a ...
packPage.command.addTo.collection=collezione
packPage.command.addTo.saved=salvato
packPage.command.share=Condividere
packPage.list.sorting.original=Originale
packPage.list.sorting.alphabetical=Alfabetico
packPage.list.filter.all=Mostra tutto
packPage.list.filter.difficult=Difficile
packPage.list.filter.banned=Ignorato
packPage.list.filter.mastered=Padroneggiato
packPage.list.filter.familiar=Familiare
packPage.list.filter.starred=Con stella
packPage.list.emptyMessage=Nessuna carta corrisponde a questo filtro
packPage.list.loadMore=Visualizza altre carte
packPage.review=Revisione
packPage.startMemo=Aggiungi alla scrivania per l''apprendimento a lungo termine
packPage.startLearning=Inizia ad imparare
packPage.speedReview=Revisione della velocità
packEmbed.clickToFlip=Clicca per capovolgere
packPage.tooltips.memoShort=La modalità di apprendimento rapido è utile quando è necessario ripetere alcune parole o domande prima dell''esame. Adatta per gruppi di parole ridotti.
packPage.tooltips.memoLong=La modalità di apprendimento a ripetizione dilazionata si basa sul metodo di ripetizione a intervalli. È utile per la preparazione sistematica agli esami e per la formazione a lungo termine.
packPage.tooltips.preview=Visualizza tutti i set di carte senza alcun controllo.
packPage.tooltips.test=Crea un test per verificare le tue conoscenze su un set di carte.
packPage.tooltips.spell=Controllo ortografico. Test di ascolto e scrittura.
##
packPlay.back=Indietro
packPlay.options=Opzioni
packPlay.progress=Progressi
packPlay.progressTemplate={0} di {1}
packPlay.wrongDisplay.title=Risposta sbagliata
packPlay.wrongDisplay.label=Risposta corretta
packPlay.wrongDisplay.continueText=Premere un tasto qualsiasi per continuare
packPlay.wrongDisplay.userLabel=Hai scritto
packPlay.wrongDisplay.typeText=Digita la risposta corretta qui sotto
##
packLearn.remaining=Rimanente
packLearn.familiar=Familiare
packLearn.mastered=Padroneggiato
packLearn.write.placeholder=scrivi qui la tua risposta
packLearn.write.placeholderCopy=copia qui la risposta corretta
packLearn.write.submit=Risposta
packLearn.write.skip=Saltare
packLearn.write.stillCorrect=Avevo ragione
packLearn.write.giveup=Abbandonare
packLearn.dialogs.options.title=Opzioni
packLearn.dialogs.options.questionTitle=Rispondi con
packLearn.dialogs.options.questionTerm=Termine
packLearn.dialogs.options.questionDefinition=Definizione
packLearn.dialogs.options.questionError=Almeno una casella di controllo dovrebbe essere selezionata
packLearn.dialogs.options.modeTitle=Tipi di domande
packLearn.dialogs.options.modeSelect=Scelta multipla
packLearn.dialogs.options.modeWrite=Scritto
packLearn.dialogs.options.modeError=Almeno una casella di controllo dovrebbe essere selezionata
packLearn.dialogs.options.modeRandom=Ordine casuale
packLearn.dialogs.options.resetTitle=Ripristina progressi
packLearn.dialogs.options.resetButton=Reset
packLearn.dialogs.options.modeCards=Schede didattiche
packLearn.dialogs.config.title=Opzioni promemoria
packLearn.dialogs.firstTime.title=Prima configurazione
packLearn.dialogs.firstTime.notice=Puoi modificare queste impostazioni nel menu "Opzioni" in qualsiasi momento
packLearn.dialogs.options.writeAnyAnswer=Scrivi una risposta qualsiasi
packLearn.dialogs.options.writeAnyAnswer.notice=Puoi scrivere solo una delle risposte disponibili (separate da virgola).
packLearn.dialogs.options.playAudio=Riproduci audio
packLearn.dialogs.options.newLimit=Nuovo limite di carte
packLearn.dialogs.options.newLimitError=Dovrebbe essere un numero positivo, minore o uguale a 50
packLearn.dialogs.options.order=Ordine di nuovo
packLearn.dialogs.options.order.original=Originale
packLearn.dialogs.options.order.random=Casuale
packLearn.dialogs.options.advancedMode=Modalità avanzata
packLearn.dialogs.options.advancedMode.notice=Per impostazione predefinita, l''"apprendimento a lungo termine" utilizza un algoritmo di apprendimento modificato a ripetizione dilazionata, in cui è sufficiente scegliere solo "So" o "Non so". Passando alla "Modalità avanzata", è possibile utilizzare un algoritmo classico con cinque opzioni disponibili, simile a Supermemo o Anki.
##
searchPage.title=Cerca "{0}"
searchPage.head=Risultati per la query "{0}"
searchPage.display.packs=Mostra set
searchPage.display.courses=Mostra corsi
searchPage.noResults.packs=Spiacenti, nessun set trovato
searchPage.noResults.courses=Spiacenti, non è stato trovato alcun corso
##
learnPage.progress.total=Passato
learnPage.progress.correct=Corretto
learnPage.progress.wrong=Sbagliato
learnPage.answer.go=Risposta
learnPage.answer.placeholder=Digita la tua risposta
learnPage.answer.unknown=Non lo so
learnPage.wrong.stillCorrect=La mia risposta è corretta!
learnPage.next=Prossimo
learnPage.result.actual=La tua risposta
learnPage.result.correct=Risposta corretta
learnPage.header.correct=Risposta corretta
learnPage.header.wrong=Risposta sbagliata
learnPage.emptyQueue=Congratulazioni! Hai superato tutte le prove.
learnPage.restartQueue=Ricomincia
learnPage.reviewComplete.title=Congratulazioni!
learnPage.reviewComplete.text=Hai passato tutte le carte.
##
testSelectPage.opt.limit=Limite di domande
testSelectPage.opt.first=Spettacolo
testSelectPage.start=Inizia il test
testSelectPage.opt.limit.prefix=Utilizzo
testSelectPage.opt.limit.suffix=di {0}
testSelectPage.opt.first.face=Termine
testSelectPage.opt.first.back=Definizione
testSelectPage.mode1=Incontro
testSelectPage.mode2=Sì / No
testSelectPage.mode3=4 opzioni
testSelectPage.mode4=Scrivere
##
testResult.message=Il tuo punteggio:
testResult.correctTitle=Risposta attesa
testResult.noAnswer=Non selezioni nulla
testResult.noAnswerWrite=Non scrivi niente
testCheck.answer=Risposta:
testCheck.answer.yes=Corretto
testCheck.answer.no=Sbagliato
testCheck.answer.correct=Corretto!
testCheck.answer.wrong=Sbagliato!
testWrite.input.placeholder=Scrivi qui la tua risposta
##
uknownPack.text=Forse avevamo già questo set... Purtroppo non è più disponibile :(
packOnVerification.text=Questo pacchetto sarà disponibile al pubblico dopo la verifica. Attendi.
##
packTest.form.questionLimit=Limite di domande
packTest.form.questionLimit.of=Di
packTest.form.questionLimit.invalid=Il conteggio delle domande non è valido.
packTest.form.questionWith=Domanda con
packTest.form.questionWith.notSelected=È richiesta almeno un''opzione.
packTest.form.requireOne=Richiedi una sola risposta
packTest.form.requireOne.explain=È richiesta almeno una risposta corretta. Le risposte devono essere separate da una barra (/), una virgola (,) o un punto e virgola (;).
packTest.form.types=Tipi di domande
packTest.form.types.notSelected=È richiesta almeno un''opzione.
packTest.form.type.choice=A scelta multipla
packTest.form.type.yn=Vero/Falso
packTest.form.type.written=Scritto
packTest.form.type.matching=Abbinamento
packTest.start=Inizia il test
packTest.qsMatching=Domande da abbinare
packTest.qsMatching.expected=La risposta corretta è:
packTest.qsWritten=Domande per la scrittura
packTest.qsWritten.inputPlaceholder=scrivi qui la tua risposta
packTest.qsWritten.expected=La risposta corretta è:
packTest.qsChoice=Domande a scelta
packTest.qsChoice.expected=La risposta corretta è:
packTest.qsYN=Domande vero/falso
packTest.qsYN.true=VERO
packTest.qsYN.false=Falso
packTest.qsYN.expected=La risposta corretta è:
packTest.checkAnswers=Controlla le risposte
packTest.score.prefix=Risultato del test:
packTest.score.90=Eccellente!
packTest.score.75=Bene!
packTest.score.50=Media
packTest.score.25=Povero
packTest.score.0=Debole
##
columns.cardsInPack=Carte
##
fexplorer.page.title={0} esploratore di flashcard
fexplorer.page.categoryTitle={0} Schede didattiche
fexplorer.title=Esploratore di flashcard
fexplorer.popularsCategories=Categorie popolari
fexplorer.language=La mia lingua
fexplorer.allCategories=Tutte le categorie
fexplorer.collections.section=Collezioni
fexplorer.flashcards.section=Schede didattiche
fexplorer.flashcards.terms=termini
fexplorer.empty.message=Si prega di selezionare una categoria <br> o <br>
fexplorer.empty.search=Cerca qualcosa
##
packPlay.progressBar.title=Progressi
packPlay.head.play=Schede didattiche
packPlay.head.learn=Imparare
packPlay.head.review=Revisione
packPlay.head.test=Test
packPlay.head.write=Scrivere
packPlay.head.memo=Promemoria
packPlay.head.spell=Sillabare
packPlay.head.match=Incontro
##
packMemo.showAnswer=Mostra risposta
packMemo.sessionComplete=Niente più carte<br>per oggi!
packMemo.sessionNextTime=Torna tra {0}.
packMemo.grades.button.H=Quasi
packMemo.grades.button.E=Facile
packMemo.grades.button.M=Medio
packMemo.grades.button.1=Cattivo
packMemo.grades.button.2=Debole
packMemo.grades.button.3=Medio
packMemo.grades.button.4=Bene
packMemo.grades.button.5=Forte
packMemo.grades.button.Y=Ok, mi ricordo
packMemo.grades.button.R=Lo so
packMemo.grades.button.F=Non lo so
packMemo.short.days=g
packMemo.short.months=me
packMemo.short.hours=o
packMemo.welcome.title=Scrivania per l''apprendimento a lungo termine
packMemo.welcome.text=È un programmatore di ripetizione dilazionata. Una volta iniziato il processo di apprendimento, imparerai 20 carte al giorno. La frequenza con cui le carte vengono mostrate dipende dalle tue risposte. Questa modalità si basa sul famoso algoritmo di ripetizione dilazionata chiamato SM-2. <br><a href="https://en.wikipedia.org/wiki/SuperMemo">Scopri di più.</a>
packMemo.welcome.start=Cominciamo
packMemo.welcome.login=Purtroppo questa modalità è disponibile solo per gli utenti autorizzati.<br>Per favore, <a href="/login">accedi</a> o <a href="/registration">registrati</a>. <br>È facile e assolutamente gratuito.




packMemo.help.title=Suggerimento
packMemo.help.line1=Barra spaziatrice per mostrare la risposta
packMemo.help.line2=1,2,3,4,5 per fare la tua scelta
packMemo.help.hide=Nascondere
packMemo.end.freshAvailable=Vuoi vedere altre nuove carte oggi?
packMemo.end.freshAccept=Sì, mostrami di più
##
fl.matchGame.welcome.text=Trascina gli elementi l''uno sull'altro per farli scomparire
fl.matchGame.startGame=Inizia il gioco
fl.matchGame.timer=Tempo
fl.matchGame.preset.number=Contare
fl.matchGame.result.title=Congratulazioni!
fl.matchGame.result.text=Il tuo punteggio è di {0} secondi
fl.matchGame.result.again=Gioca di nuovo
##
fl.memoHeatMap.title=La tua cronologia di apprendimento
fl.memoHeatMap.legend.daverage=Media giornaliera:
fl.memoHeatMap.legend.daverage.value={0} {0,plural,one{carta}few{carte}other{carte}}
fl.memoHeatMap.legend.dlearned=Giorni appresi:

fl.memoHeatMap.legend.beststreak=Miglior serie:
fl.memoHeatMap.legend.beststreak.value={0} {0,plural,one{giorno}few{giorni}other{giorni}}
fl.memoHeatMap.legend.currentstreak=Serie attuale:
fl.memoHeatMap.legend.currentstreak.value={0} {0,plural,one{giorno}few{giorni}other{giorni}}
fl.memoHeatMap.tooltip.passed={0} {0,plural,one{revisione superata}few{recensioni superate}other{recensioni superate}}
fl.memoHeatMap.tooltip.failed={0} {0,plural,one{revisione fallita}few{recensioni fallite}other{recensioni fallite}}
fl.memoHeatMap.tooltip.fresh={0} {0,plural,one{carta fresca}few{nuove carte}other{nuove carte}}
fl.memoHeatMap.tooltip.date=su {0}
##
cardButtons.ban.title=Vieta questa carta
cardButtons.edit.title=Correggi questa carta
cardButtons.star.title=Attiva/disattiva la carta preferita
cardButtons.ban.prompt=Ignorare questa carta?
##
validation.cardText.tooLong=La lunghezza massima di questo testo è di 1000 caratteri
##
extLocale.la=latino
extLocale.rw=Kinyarwanda
extLocale.af=afrikaans
extLocale.am=amarico
extLocale.az=Azero
extLocale.bn=Bengala
extLocale.bs=bosniaco
extLocale.ceb=Cebuano
extLocale.co=Corso
extLocale.cy=gallese
extLocale.eo=esperanto
extLocale.eu=basco
extLocale.fa=persiano
extLocale.fy=Frisone
extLocale.gd=Scozzese (gaelico)
extLocale.gl=galiziano
extLocale.gu=Gujarati
extLocale.ha=Casa
extLocale.haw=hawaiano
extLocale.hmn=Hmong
extLocale.ht=Creolo (Haiti)
extLocale.hy=armeno
extLocale.id=indonesiano
extLocale.ig=Igbo
extLocale.jw=giavanese
extLocale.ka=georgiano
extLocale.kk=kazako
extLocale.km=Khmer
extLocale.kn=Kannada
extLocale.ku=Kurmanji
extLocale.ky=Kirghizistan
extLocale.lb=Lussemburgo
extLocale.lo=Laotiano
extLocale.mg=malgascio
extLocale.mi=Maori
extLocale.ml=Malayalam
extLocale.mn=mongolo
extLocale.mr=Marathi
extLocale.my=birmano
extLocale.ne=Nepalese
extLocale.ny=Ceva
extLocale.or=Oria
extLocale.pa=Punjabi
extLocale.ps=Pashtu
extLocale.sd=Sindhi
extLocale.si=singalese
extLocale.sm=Samoano
extLocale.sn=Shona
extLocale.so=Somalo
extLocale.st=Sesotho
extLocale.su=sudanese
extLocale.sw=Swahili
extLocale.ta=Tamil
extLocale.te=Telugu
extLocale.tg=Tagiko
extLocale.tk=Turkmen
extLocale.tl=filippino
extLocale.tt=tartaro
extLocale.ug=Uiguro
extLocale.ur=Urdu
extLocale.uz=Uzbeko
extLocale.xh=Xhosa
extLocale.yi=yiddish
extLocale.yo=Yoruba
extLocale.zu=Zulu


# landing
fl.landing.title=Imparare con {0}
fl.landing.title.small=Scopri cosa {0} può aggiungere al tuo processo di apprendimento
fl.landing.why1.title=È facile e divertente
fl.landing.why1.text=Migliaia di studenti e studenti fanno i compiti ogni giorno su {0}, migliorando i loro voti. Sul divano, in metropolitana, in coda: c''è sempre qualche minuto per studiare.
fl.landing.why2.title=Sei modalità di apprendimento
fl.landing.why2.text=Scegli gli strumenti più adatti alle informazioni che devi apprendere.
fl.landing.why3.title=Ripetizione distanziata
fl.landing.why3.text=Basato sullo studio della psicologia, il metodo della ripetizione dilazionata consente di ricordare grandi quantità di informazioni senza sforzi eccessivi. Basta studiare per 10-15 minuti al giorno.
fl.landing.why4.title=Su qualsiasi dispositivo
fl.landing.why4.text=Lavora sul dispositivo che hai a portata di mano. Non importa se si tratta di un computer, un tablet o uno smartphone: i nostri strumenti sono ottimizzati per ogni dispositivo.
fl.landing.create.title=Crea i tuoi set di carte
fl.landing.create1.title=Creare memorizzare
fl.landing.create1.text=Per preparare un set, è necessario strutturare e semplificare le informazioni. Questo è uno dei modi migliori per padroneggiare la materia. In futuro, non ti resterà che rinfrescare la memoria.
fl.landing.create2.title=Importazione conveniente
fl.landing.create2.text=Utilizza lo strumento flessibile di importazione di flashcard da file di testo per caricare set da altre fonti. Puoi anche importare un file ANKI.
fl.landing.create3.title=Modificare
fl.landing.create3.text=Scegli un set adatto dal nostro database, modificalo e integralo in base al tuo curriculum.
fl.landing.create.button=Crea un set
fl.landing.gallery=Esempi
fl.landing.gallery.others=Vedi altri esempi
fl.landing.stars1=3 milioni di studenti ogni mese
fl.landing.stars2=Oltre 100.000.000 di sessioni di formazione
fl.landing.stars3=Oltre 1.000.000 kit didattici
fl.landing.reg1=Iscriviti subito e usufruisci di schede didattiche sull''allenamento a intervalli, raccolte didattiche e utili documenti didattici.
fl.landing.reg2=Non hai un account Google o Facebook? Nessun problema! Registrati con la tua email.
## fast add card










## uninstall page
fl_uninstall_title=Grazie per aver utilizzato Studylib Extension.
fl_uninstall_subtitle=Ci dispiace vederti andare via! Se hai un momento, dicci come possiamo migliorare Extension:
fl_uninstall_notice=Il tuo feedback ci aiuta a migliorare il prodotto per tutti, grazie 😊
fl_uninstall_button=Inviare
fl_uninstall_success=Arrivederci!

## APPEND ITEMS ABOVE THIS LINE